import Joi from 'joi';
import _ from 'lodash';
import { TCompanyFieldsFragment, TDeliveryMethod, TListOfficesQuery } from '../../generated/graphql';
import { phoneNumberExtension } from '../../shared/validations/phoneNumber';
import { getAddressDefaultValues, getAddressSchema } from '../address/schema';
import { getEmployeeDependantSchema } from '../dependant/schema';
import { clearableField } from '../shared/clearableField';
import { AWSDateSchema } from '../shared/utils';
import { TGetEmployee } from './shared';

type TGetEmployeeSchemaProps = {
  addDependants?: boolean;
  company: TCompanyFieldsFragment;
  offices?: TListOfficesQuery['listOffices']['items'];
};

export const getEmployeeSchema = (props: TGetEmployeeSchemaProps) => {
  const { company, offices } = props;

  const employeeSchema = Joi.object()
    .unknown(false)
    .keys({
      id: Joi.forbidden(),
      address: getAddressSchema(company.deliveryMethod == TDeliveryMethod.Home),
      // active: Joi.boolean().empty(Joi.valid(null, '')).default(true),
      // externalId: Joi.string().trim().empty(Joi.valid('')).default(null).allow(null),
      companyId: Joi.forbidden(),
      officeId: clearableField(
        Joi.string()
          .trim()
          .valid(..._.compact(offices).map((o) => o.id))
          .optional()
      ),
      externalId: clearableField(Joi.string().trim()),
      firstName: Joi.string().trim().required(),
      preferredFirstName: clearableField(Joi.string().trim()),
      lastName: clearableField(Joi.string().trim()),
      hireDate: clearableField(AWSDateSchema),
      birthDate: clearableField(AWSDateSchema),
      email: clearableField(
        Joi.string()
          .trim()
          .lowercase()
          .email({
            tlds: {
              allow: false
            }
          })
      ),
      phoneNumber: Joi.alternatives(clearableField(Joi.extend(phoneNumberExtension).phoneNumber()), clearableField(Joi.array().items(Joi.extend(phoneNumberExtension).phoneNumber()))),
      foodPreferences: clearableField(Joi.string().trim()),
      customOnboardBrick: clearableField(Joi.string().trim()),
      title: clearableField(Joi.string().trim()),
      organization: clearableField(Joi.string().trim()),
      deliveryMethod: Joi.string().empty(Joi.valid(null, '')).valid('home', 'office', 'default'),
      tShirtSize: clearableField(Joi.string().trim()),
      sweaterSize: clearableField(Joi.string().trim()),
      donateBirthdayGift: Joi.boolean().empty(Joi.valid(null, '')).default(false),
      donateWorkAnniversaryGift: Joi.boolean().empty(Joi.valid(null, '')).default(false),
      dependants: Joi.array().items(getEmployeeDependantSchema()).optional()
    });

  // if (company.employeeNewHireKitActivated || company.employeeWorkAnniversaryActivated) employeeSchema = employeeSchema.fork(['hireDate'], (schema) => schema.required());
  // if (company.employeeBirthdayActivated) employeeSchema = employeeSchema.fork(['birthDate'], (schema) => schema.required());

  return employeeSchema;
};

export const getEmployeeDefaultValues = (employee?: TGetEmployee | null) => {
  return {
    ..._.pick(
      employee || {},
      'externalId',
      'firstName',
      'preferredFirstName',
      'lastName',
      // 'hireDate',
      // 'birthDate',
      'email',
      'phoneNumber',
      'foodPreferences',
      'tShirtSize',
      'sweaterSize',
      'donateBirthdayGift',
      'donateWorkAnniversaryGift'
    ),
    officeId: employee?.officeId || employee?.office?.id,
    address: getAddressDefaultValues(employee?.address),
    birthDate: employee?.birthDate,
    hireDate: employee?.hireDate
  };
};
